/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.1.0 (NJsonSchema v10.4.3.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    
  /** If group 7 matches is UTC, if 8 match is DateTime with Offset, else just a plain old DateTime */
  private static reDt = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:(Z)|([+\-])(\d{2}):(\d{2}))?$/;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
    this.jsonParseReviver = (key: string, value: any) => {
      if (typeof value === 'string') {
        const m = ApiClient.reDt.exec(value);
        if (m) {
          const year = +m[1];
          const month = +m[2] - 1;
          const day = +m[3];
          const hour = +m[4];
          const minute = +m[5];
          const secondsAndMs = +m[6];
          const seconds = Math.floor(secondsAndMs);
          const milliseconds = secondsAndMs * 1000 % 1000;

          if (m[7] !== undefined) {
            // utc date? 
            return new Date(Date.UTC(year, month, day, hour, minute, seconds, milliseconds));
          }
          else if (m[8] !== undefined) {
            const dt = new Date(year, month, day, hour, minute, seconds, milliseconds);
            const negationFactor = (m[8] === '-') ? -1 : 1;
            const originalTimeZoneOffset = (+m[9]) * 60 * negationFactor + +m[10] * negationFactor;
            const minutesDifference = dt.getTimezoneOffset() + originalTimeZoneOffset;
            if (minutesDifference !== 0) {
              dt.setTime(dt.getTime() - minutesDifference * 60 * 1000);
            }
            return dt;
          } {
            return new Date(year, month, day, hour, minute, seconds, milliseconds);
          }

        }
      }
      return value;
    };
  }

    /**
     * @param id (optional) 
     * @param surveyCycleId (optional) 
     * @param section (optional) 
     * @param subjectUserId (optional) 
     * @param submitterUserId (optional) 
     * @param createdOn (optional) 
     * @param comment (optional) 
     * @return Success
     */
    getSectionComment(id: number | undefined, surveyCycleId: number | undefined, section: number | undefined, subjectUserId: number | undefined, submitterUserId: number | undefined, createdOn: Date | undefined, comment: string | undefined): Observable<SwaggerResponse<SurveySectionCommentsResource>> {
        let url_ = this.baseUrl + "/api/comments/get-section-comment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (surveyCycleId === null)
            throw new Error("The parameter 'surveyCycleId' cannot be null.");
        else if (surveyCycleId !== undefined)
            url_ += "SurveyCycleId=" + encodeURIComponent("" + surveyCycleId) + "&";
        if (section === null)
            throw new Error("The parameter 'section' cannot be null.");
        else if (section !== undefined)
            url_ += "Section=" + encodeURIComponent("" + section) + "&";
        if (subjectUserId === null)
            throw new Error("The parameter 'subjectUserId' cannot be null.");
        else if (subjectUserId !== undefined)
            url_ += "SubjectUserId=" + encodeURIComponent("" + subjectUserId) + "&";
        if (submitterUserId === null)
            throw new Error("The parameter 'submitterUserId' cannot be null.");
        else if (submitterUserId !== undefined)
            url_ += "SubmitterUserId=" + encodeURIComponent("" + submitterUserId) + "&";
        if (createdOn === null)
            throw new Error("The parameter 'createdOn' cannot be null.");
        else if (createdOn !== undefined)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toJSON() : "") + "&";
        if (comment === null)
            throw new Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "Comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectionComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectionComment(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<SurveySectionCommentsResource>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<SurveySectionCommentsResource>>><any>_observableThrow(response_);
        }));
    }

    protected processGetSectionComment(response: HttpResponseBase): Observable<SwaggerResponse<SurveySectionCommentsResource>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SurveySectionCommentsResource>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SurveySectionCommentsResource>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putSectionComment(body: SurveySectionCommentsResource | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/comments/put-section-comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutSectionComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutSectionComment(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<void>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<void>>><any>_observableThrow(response_);
        }));
    }

    protected processPutSectionComment(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getSurveyRelationshipTypes(): Observable<SwaggerResponse<SurveyRelationshipType[]>> {
        let url_ = this.baseUrl + "/api/config/surveyRelationshipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyRelationshipTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyRelationshipTypes(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<SurveyRelationshipType[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<SurveyRelationshipType[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyRelationshipTypes(response: HttpResponseBase): Observable<SwaggerResponse<SurveyRelationshipType[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SurveyRelationshipType[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SurveyRelationshipType[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getCurrentSurveyCycle(): Observable<SwaggerResponse<SurveyCycle>> {
        let url_ = this.baseUrl + "/api/cycles/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentSurveyCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentSurveyCycle(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<SurveyCycle>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<SurveyCycle>>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentSurveyCycle(response: HttpResponseBase): Observable<SwaggerResponse<SurveyCycle>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SurveyCycle>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SurveyCycle>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param finalize (optional) 
     * @param body (optional) 
     * @return Success
     */
    postSurveyCycleFeedback(finalize: boolean | undefined, body: FormSubmission | undefined): Observable<SwaggerResponse<FieldInstanceBase[]>> {
        let url_ = this.baseUrl + "/api/cycles/submissions?";
        if (finalize === null)
            throw new Error("The parameter 'finalize' cannot be null.");
        else if (finalize !== undefined)
            url_ += "finalize=" + encodeURIComponent("" + finalize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSurveyCycleFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSurveyCycleFeedback(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FieldInstanceBase[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FieldInstanceBase[]>>><any>_observableThrow(response_);
        }));
    }

    protected processPostSurveyCycleFeedback(response: HttpResponseBase): Observable<SwaggerResponse<FieldInstanceBase[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FieldInstanceBase[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FieldInstanceBase[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getFieldTypes(): Observable<SwaggerResponse<{ [key: string]: number; }>> {
        let url_ = this.baseUrl + "/api/forms/fieldTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldTypes(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<{ [key: string]: number; }>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<{ [key: string]: number; }>>><any>_observableThrow(response_);
        }));
    }

    protected processGetFieldTypes(response: HttpResponseBase): Observable<SwaggerResponse<{ [key: string]: number; }>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <{ [key: string]: number; }>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<{ [key: string]: number; }>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getFormBySurveyId(surveyId: number): Observable<SwaggerResponse<FormDefinition>> {
        let url_ = this.baseUrl + "/api/forms/surveys/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormBySurveyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormBySurveyId(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FormDefinition>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FormDefinition>>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormBySurveyId(response: HttpResponseBase): Observable<SwaggerResponse<FormDefinition>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FormDefinition>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FormDefinition>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getFormBySurveyCycleId(surveyCycleId: number): Observable<SwaggerResponse<FormDefinition>> {
        let url_ = this.baseUrl + "/api/forms/survey-cycles/{surveyCycleId}";
        if (surveyCycleId === undefined || surveyCycleId === null)
            throw new Error("The parameter 'surveyCycleId' must be defined.");
        url_ = url_.replace("{surveyCycleId}", encodeURIComponent("" + surveyCycleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormBySurveyCycleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormBySurveyCycleId(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FormDefinition>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FormDefinition>>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormBySurveyCycleId(response: HttpResponseBase): Observable<SwaggerResponse<FormDefinition>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FormDefinition>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FormDefinition>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getSavedSubmission(submissionId: number): Observable<SwaggerResponse<FormInstance>> {
        let url_ = this.baseUrl + "/api/forms/submissions/{submissionId}";
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSavedSubmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSavedSubmission(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FormInstance>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FormInstance>>><any>_observableThrow(response_);
        }));
    }

    protected processGetSavedSubmission(response: HttpResponseBase): Observable<SwaggerResponse<FormInstance>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FormInstance>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FormInstance>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reports(): Observable<SwaggerResponse<ReportInfo[]>> {
        let url_ = this.baseUrl + "/api/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReports(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<ReportInfo[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<ReportInfo[]>>><any>_observableThrow(response_);
        }));
    }

    protected processReports(response: HttpResponseBase): Observable<SwaggerResponse<ReportInfo[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ReportInfo[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReportInfo[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getCurrentUserFeedbackReport(surveyCycleId: number): Observable<SwaggerResponse<FeedbackSummary>> {
        let url_ = this.baseUrl + "/api/reports/{surveyCycleId}/users/me";
        if (surveyCycleId === undefined || surveyCycleId === null)
            throw new Error("The parameter 'surveyCycleId' must be defined.");
        url_ = url_.replace("{surveyCycleId}", encodeURIComponent("" + surveyCycleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserFeedbackReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserFeedbackReport(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FeedbackSummary>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FeedbackSummary>>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUserFeedbackReport(response: HttpResponseBase): Observable<SwaggerResponse<FeedbackSummary>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FeedbackSummary>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FeedbackSummary>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getUserFeedbackReport(surveyCycleId: number, userId: number): Observable<SwaggerResponse<FeedbackSummary>> {
        let url_ = this.baseUrl + "/api/reports/{surveyCycleId}/users/{userId}";
        if (surveyCycleId === undefined || surveyCycleId === null)
            throw new Error("The parameter 'surveyCycleId' must be defined.");
        url_ = url_.replace("{surveyCycleId}", encodeURIComponent("" + surveyCycleId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserFeedbackReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserFeedbackReport(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FeedbackSummary>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FeedbackSummary>>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserFeedbackReport(response: HttpResponseBase): Observable<SwaggerResponse<FeedbackSummary>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FeedbackSummary>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FeedbackSummary>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getFeedbackReportCsv(surveyCycleId: number): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/reports/{surveyCycleId}/csv";
        if (surveyCycleId === undefined || surveyCycleId === null)
            throw new Error("The parameter 'surveyCycleId' must be defined.");
        url_ = url_.replace("{surveyCycleId}", encodeURIComponent("" + surveyCycleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackReportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackReportCsv(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeedbackReportCsv(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: <any>responseBlob, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getUsers(): Observable<SwaggerResponse<UserSummary[]>> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<UserSummary[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<UserSummary[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<SwaggerResponse<UserSummary[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UserSummary[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getCurrentUser(): Observable<SwaggerResponse<UserSummary>> {
        let url_ = this.baseUrl + "/api/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<UserSummary>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<UserSummary>>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<SwaggerResponse<UserSummary>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserSummary>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UserSummary>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export interface FeedbackSummary {
    subjectId: number | undefined;
    subjectName: string | undefined;
    submissions: FormReport[] | undefined;
    groups: GroupReport[] | undefined;
    sectionsComments: SurveySectionCommentsResource[] | undefined;
}

export interface FieldInstanceBase {
    createdByOid: string | undefined;
    createdOn: Date | undefined;
    deletedOn: Date | undefined;
    fieldInstanceId: number | undefined;
    fieldId: number | undefined;
    value: string | undefined;
}

export interface FieldSubmission {
    fieldId: number;
    value: string | undefined;
}

export interface FormDefinition {
    surveyId: number | undefined;
    formId: number;
    ownerOid: string;
    sections: FormSection[] | undefined;
    deletedOn: Date | undefined;
    displayName: string | undefined;
    name: string;
}

export interface FormInstance {
    createdByOid: string | undefined;
    createdOn: Date | undefined;
    fields: FieldInstanceBase[] | undefined;
    deletedOn: Date | undefined;
    externalId: string | undefined;
    formId: number | undefined;
    formInstanceId: number | undefined;
    meta: any | undefined;
}

export interface FormReport {
    fields: FieldSubmission[] | undefined;
    surveyCycleId: number;
    surveyRelationshipTypeId: number;
}

export interface FormSection {
    sectionId: number;
    fields: FormSectionField[] | undefined;
    content: string | undefined;
    heading: string | undefined;
    name: string;
    orderIndex: number;
}

export interface FormSectionField {
    fieldId: number;
    orderIndex: number;
    content: string | undefined;
    defaultValue: string | undefined;
    deletedOn: Date | undefined;
    fieldTypeId: number;
    heading: string | undefined;
    isEncrypted: boolean;
    meta: any | undefined;
    name: string;
}

export interface FormSubmission {
    fields: FieldSubmission[] | undefined;
    surveyCycleId: number;
    subjectUserId: number;
}

export interface GroupReport {
    surveyCycleId: number;
    groupId: number;
    name: string | undefined;
    fieldSums: { [key: string]: number; } | undefined;
    submissionCount: number;
}

export interface ReportInfo {
    surveyCycleId: number;
    surveyId: number;
    cycleName: string | undefined;
    subjectResultsAvailable: boolean;
    surveyName: string | undefined;
    viewableUsers: ReportSubject[] | undefined;
    viewerResultsAvailable: boolean;
    csvFileAvailable: boolean;
}

export interface ReportSubject {
    id: number;
    name: string | undefined;
    viewerId: number;
}

export interface SurveyCycle {
    surveyCycleId: number;
    surveyId: number;
    cycleName: string | undefined;
    usersAwaitingFeedback: SurveyUser[] | undefined;
    hasEnded: boolean;
}

export interface SurveyRelationshipType {
    surveyRelationshipTypeId: number;
    name: string | undefined;
}

export interface SurveySectionCommentsResource {
    id: number;
    surveyCycleId: number;
    section: number;
    subjectUserId: number;
    submitterUserId: number;
    createdOn: Date | undefined;
    comment: string | undefined;
}

export interface SurveyUser {
    id: number;
    email: string | undefined;
    name: string | undefined;
    isActive: boolean | undefined;
    isSuperUser: boolean;
    isSuperViewer: boolean;
    inProgressSubmissionId: number | undefined;
}

export interface UserSummary {
    id: number;
    email: string | undefined;
    name: string | undefined;
    isActive: boolean | undefined;
    isSuperUser: boolean;
    isSuperViewer: boolean;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}